import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailActu1 = () => {
  // Article Lancement CINEF-EC
  const article = {
    id: 2,
    title:
      "Lancement officiel : CINEF-EXPERTISE COMPTABLE ouvre ses portes pour accompagner la croissance des entreprises au bénin",
    excerpt:
      "Une nouvelle ère de conseil et d'accompagnement pour les entreprises béninoises et de la sous-région s'ouvre aujourd'hui.",
    content: `
      <p class="text-muted mb-3"><strong>Cotonou, le 01 Octobre 2025</strong></p>
      
      <p class="lead">Le cabinet <strong>CINEF-EXPERTISE COMPTABLE</strong> (CINEF-EC) annonce avec enthousiasme le lancement officiel de ses activités. Notre mission : offrir des services d'expertise comptable, de conseil fiscal et de gestion d'entreprise de premier ordre, conçus pour catalyser votre succès.</p>
      
      <p>Dans un environnement économique en constante évolution, la rigueur financière et une stratégie claire sont les piliers de toute entreprise prospère. C'est avec cette conviction que CINEF-EXPERTISE COMPTABLE se positionne comme votre partenaire de confiance, engagé à vos côtés pour relever les défis de la croissance et de la conformité.</p>

      <h3>Une gamme de services intégrés pour une performance optimale</h3>
      
      <p>Nous comprenons que chaque entreprise est unique. C'est pourquoi nous proposons une approche sur mesure, articulée autour de plusieurs pôles d'excellence :</p>
      
      <ul>
        <li><strong>Expertise Comptable & Financière :</strong> De la tenue de votre comptabilité à l'établissement de vos états financiers, en passant par l'audit contractuel et légal, nous garantissons la fiabilité et la transparence de votre information financière, un atout majeur pour vos prises de décision et vos relations avec les partenaires (banques, investisseurs).</li>
        
        <li><strong>Conseil Fiscal & Juridique :</strong> Naviguez avec sérénité dans le labyrinthe des réglementations. Notre équipe vous assiste dans l'optimisation de votre charge fiscale, la gestion de vos déclarations et vous conseille sur les aspects juridiques liés à la vie de votre entreprise.</li>
        
        <li><strong>Conseil en Gestion & Organisation :</strong> Au-delà des chiffres, nous vous aidons à structurer votre organisation, à mettre en place des outils de pilotage performants (tableaux de bord, business plan) et à optimiser vos processus pour une meilleure rentabilité.</li>
        
        <li><strong>Accompagnement à la Création d'Entreprise :</strong> Vous êtes porteur d'un projet ? Nous vous accompagnons à chaque étape, de l'idée à l'immatriculation, pour bâtir des fondations solides pour votre future entreprise.</li>
      </ul>

      <h3>Notre Engagement : Proximité, Rigueur et Innovation</h3>
      
      <p>Chez CINEF-EXPERTISE COMPTABLE, nous croyons en une relation client basée sur l'écoute et la disponibilité. Notre ambition n'est pas seulement d'être votre prestataire, mais un véritable allié stratégique, proactif et investi dans la réussite de vos projets.</p>

      <h3>Découvrez notre uivers et rencontrons-nous !</h3>
      
      <p>Nous invitons tous les dirigeants d'entreprises, entrepreneurs et partenaires financiers à découvrir l'étendue de nos solutions en visitant notre site internet. Explorez nos offres et comprenez comment nous pouvons concrètement contribuer à votre développement.</p>
      
      <div class="contact-info bg-light p-4 rounded mb-4">
        <h5 class="mb-3">🌐 <strong>Visitez-nous en ligne sur :</strong></h5>
        <ul class="list-unstyled">
          <li class="mb-2">• <a href="https://www.cinef-expertises.com" target="_blank" rel="noopener noreferrer"><strong>www.cinef-expertises.com</strong></a></li>
          <li>• <a href="https://www.cinef-expertises.bj" target="_blank" rel="noopener noreferrer"><strong>www.cinef-expertises.bj</strong></a></li>
        </ul>
        
        <p className="mt-3 text-gray-700">
          un échange direct et une analyse personnalisée de vos besoins, notre équipe se tient à votre entière disposition à notre siège. 
          Réservez dès aujourd'hui votre créneau
  <a
    href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ30HiUAglAWfWtbsla-NeJVC3PrBwr9y2_8BzlRazyhV4YI0qYb89EJJ8l2yuCAzfRQ6-0hqkcK?gv=true"
    target="_blank"
    rel="noopener noreferrer"
    className="text-green-600 font-semibold hover:underline hover:text-green-700 transition-colors"
  >
    ici
  </a>.
 </p>

      </div>
      
      <div class="address-info bg-success text-white p-4 rounded mb-4">
        <h5 class="mb-3">📍 <strong>Retrouvez-nous à notre siège social :</strong></h5>
        <p class="mb-2">Cotonou, quartier Sainte Rita, Immeuble BOCOVE, en face de l'Église catholique Ste Rita.</p>
        <p class="mb-0"><strong>Tél.</strong> +229 01 63 18 60 60 / 01 21 60 23 44</p>
      </div>
      
      <blockquote class="text-center">
        <strong>CINEF-EXPERTISE COMPTABLE : Nous nous engageons avec vous…</strong>
      </blockquote>
    `,
    image: "/assets/images/Actu1.jpg",
    category: "Actualités",
    date: "24 septembre 2025",
    author: "CINEF-EC",
    readTime: "5 min",
    tags: [
      "Lancement",
      "CINEF-EC",
      "Expertise Comptable",
      "Bénin",
      "Entreprises",
      "Services",
    ],
  };

  // Articles similaires
  const similarArticles = [
    {
      id: 3,
      title: "Comment optimiser la comptabilité de votre TPE en 2025",
      image: "/assets/images/image2.png",
      date: "5 avril 2025",
      category: "Comptabilité",
    },
    {
      id: 5,
      title: "Les enjeux de la RSE pour les PME en 2025",
      image: "/assets/images/image6.png",
      date: "20 mars 2025",
      category: "RSE",
    },
  ];

  return (
    <>
      <Header />

      <div className="article-content py-5">
        <div className="container">
          {/* Fil d'Ariane */}
          {/* <nav className="breadcrumb-container mb-4">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="text-decoration-none">Accueil</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/actualites" className="text-decoration-none">Actualités</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {article.title}
              </li>
            </ol>
          </nav> */}

          <div className="row">
            <div className="col-lg-8">
              {/* Catégorie et Titre */}
              <div className="article-header mb-4">
                <span className="category-badge">{article.category}</span>
                <h1 className="article-title mt-3">{article.title}</h1>

                {/* Métadonnées de l'article */}
                <div className="article-meta d-flex align-items-center mt-3">
                  <div className="meta-item d-flex align-items-center">
                    <FaCalendarAlt className="meta-icon" />
                    <span>{article.date}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaUser className="meta-icon" />
                    <span>{article.author}</span>
                  </div>
                  <div className="meta-item d-flex align-items-center">
                    <FaClock className="meta-icon" />
                    <span>{article.readTime} de lecture</span>
                  </div>
                </div>
              </div>

              {/* Image principale */}
              <div className="article-featured-image mb-4">
                <img
                  src="../assets/images/image19.png"
                  alt={article.title}
                  className="img-fluid rounded"
                />
              </div>

              {/* Extrait de l'article */}
              <div className="article-excerpt mb-4">
                <p className="lead">{article.excerpt}</p>
              </div>

              {/* Contenu principal */}
              <div
                className="article-body mb-5"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />

              {/* Tags */}

              {/* Partage sur les réseaux sociaux */}
              <div className="article-share mb-5">
                <h5 className="share-title">Partager cet article</h5>
                <div className="social-buttons">
                  <a href="#" className="social-button linkedin">
                    <FaLinkedin />
                  </a>
                  <a href="#" className="social-button twitter">
                    <FaTwitter />
                  </a>
                  <a href="#" className="social-button facebook">
                    <FaFacebook />
                  </a>
                </div>
              </div>

              {/* Bouton Retour */}
              <div className="article-actions mb-5">
                <Link to="/actualites" className="btn btn-back">
                  <FaChevronLeft className="me-2" /> Retour aux actualités
                </Link>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              {/* À propos de l'auteur */}
              <div className="sidebar-widget author-widget">
                <h4 className="widget-title">À propos de l'auteur</h4>
                <div className="author-profile">
                  <div className="author-image">
                    <img
                      src="../assets/images/image3.png"
                      alt={article.author}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className="author-info">
                    <h5 className="author-name">{article.author}</h5>
                    <p className="author-bio">
                      Cabinet d'expertise comptable spécialisé dans
                      l'accompagnement des entreprises et des secteurs créatifs
                      en Afrique francophone.
                    </p>
                  </div>
                </div>
              </div>

              {/* Articles similaires */}
              <div className="sidebar-widget similar-articles-widget">
                <h4 className="widget-title">Articles similaires</h4>
                <div className="similar-articles">
                  {similarArticles.map((similarArticle) => (
                    <Link
                      key={similarArticle.id}
                      to={`/actualites/${similarArticle.id}`}
                      className="similar-article"
                    >
                      <div className="similar-article-image">
                        <img
                          src={similarArticle.image}
                          alt={similarArticle.title}
                          className="img-fluid rounded"
                        />
                        <span className="category-badge small">
                          {similarArticle.category}
                        </span>
                      </div>
                      <div className="similar-article-content">
                        <h5 className="similar-article-title">
                          {similarArticle.title}
                        </h5>
                        <div className="similar-article-date">
                          <FaCalendarAlt className="me-1" size={12} />
                          <small>{similarArticle.date}</small>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Widget Newsletter */}
              <div className="sidebar-widget newsletter-widget">
                <h4 className="widget-title">Newsletter</h4>
                <p className="newsletter-desc">
                  Restez informé des dernières actualités fiscales et comptables
                </p>
                <form className="newsletter-form">
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Votre adresse email"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">
                    S'abonner
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        /* Import des polices Google */
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Playfair+Display:wght@700;800&display=swap");

        /* Variables CSS */
        :root {
          --color-primary-red: #dc3545;
          --color-primary-green: #198754;
          --color-dark: #1a1a1a;
          --color-gray-dark: #4a4a4a;
          --color-gray: #6c757d;
          --color-gray-light: #e9ecef;
          --color-white: #ffffff;
          --font-primary: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
            sans-serif;
          --font-heading: "Playfair Display", Georgia, serif;
          --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);
          --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);
          --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        /* Styles généraux */
        .article-content {
          background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
          font-family: var(--font-primary);
          color: var(--color-dark);
        }

        /* Fil d'Ariane */
        .breadcrumb-container {
          padding: 1rem 0;
        }

        .breadcrumb {
          background-color: transparent;
          padding: 0;
          margin-bottom: 0;
          font-size: 0.875rem;
          font-weight: 500;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          color: var(--color-gray);
          content: "›";
          font-size: 1.2rem;
        }

        .breadcrumb-item a {
          color: var(--color-gray);
          text-decoration: none;
          transition: var(--transition);
        }

        .breadcrumb-item a:hover {
          color: var(--color-primary-red);
        }

        .breadcrumb-item.active {
          color: var(--color-dark);
          font-weight: 600;
        }

        /* En-tête de l'article */
        .article-header {
          margin-bottom: 2.5rem;
        }

        .article-title {
          font-family: var(--font-heading);
          font-size: 2rem;
          font-weight: 800;
          line-height: 1.2;
          margin-top: 1rem;
          margin-bottom: 1.5rem;
          color: var(--color-dark);
          letter-spacing: -0.02em;
        }

        .category-badge {
          display: inline-block;
          background: linear-gradient(
            135deg,
            var(--color-primary-red) 0%,
            var(--color-primary-green) 100%
          );
          color: white;
          padding: 0.5rem 1.25rem;
          border-radius: 50px;
          font-size: 0.813rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          box-shadow: 0 4px 12px rgba(220, 53, 69, 0.25);
        }

        .article-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 1.5rem;
          padding: 1rem 0;
          border-top: 1px solid var(--color-gray-light);
          border-bottom: 1px solid var(--color-gray-light);
        }

        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: var(--color-gray-dark);
          font-size: 0.875rem;
          font-weight: 500;
        }

        .meta-icon {
          color: var(--color-primary-red);
          font-size: 1rem;
        }

        /* Image principale */
        .article-featured-image {
          border-radius: 16px;
          overflow: hidden;
          box-shadow: var(--shadow-lg);
          margin-bottom: 2.5rem;
          position: relative;
        }

        .article-featured-image::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.05) 100%
          );
          pointer-events: none;
        }

        .article-featured-image img {
          transition: transform 0.6s ease;
        }

        .article-featured-image:hover img {
          transform: scale(1.02);
        }

        /* Extrait */
        .article-excerpt {
          background: linear-gradient(
            135deg,
            rgba(220, 53, 69, 0.05) 0%,
            rgba(25, 135, 84, 0.05) 100%
          );
          border-left: 4px solid var(--color-primary-red);
          padding: 1.5rem 2rem;
          border-radius: 0 12px 12px 0;
          margin-bottom: 2.5rem;
        }

        .article-excerpt .lead {
          font-size: 1.25rem;
          font-weight: 400;
          line-height: 1.7;
          color: var(--color-gray-dark);
          margin-bottom: 0;
        }

        /* Contenu de l'article */
        .article-body {
          font-size: 1.063rem;
          line-height: 1.8;
          color: var(--color-dark);
          text-align: justify;
        }

        .article-body h3 {
          font-family: var(--font-heading);
          font-size: 1.75rem;
          font-weight: 700;
          color: var(--color-dark);
          margin-top: 2.5rem;
          margin-bottom: 1.25rem;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid transparent;
          border-image: linear-gradient(
              to right,
              var(--color-primary-red),
              var(--color-primary-green)
            )
            1;
          letter-spacing: -0.01em;
        }

        .article-body p {
          margin-bottom: 1.5rem;
        }

        .article-body ul {
          margin: 1.5rem 0;
          padding-left: 0;
          list-style: none;
        }

        .article-body li {
          margin-bottom: 1.25rem;
          padding-left: 2rem;
          position: relative;
          line-height: 1.7;
        }

        .article-body li::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0.6rem;
          width: 8px;
          height: 8px;
          background: linear-gradient(
            135deg,
            var(--color-primary-red),
            var(--color-primary-green)
          );
          border-radius: 50%;
        }

        .article-body strong {
          color: var(--color-dark);
          font-weight: 700;
        }

        .article-body blockquote {
          background: linear-gradient(
            135deg,
            rgba(220, 53, 69, 0.08) 0%,
            rgba(25, 135, 84, 0.08) 100%
          );
          border-left: 4px solid var(--color-primary-green);
          padding: 1.5rem 2rem;
          margin: 2.5rem 0;
          border-radius: 0 12px 12px 0;
          font-style: italic;
          font-size: 1.125rem;
          color: var(--color-gray-dark);
          box-shadow: var(--shadow-sm);
        }

        .article-body a {
          color: var(--color-primary-red);
          text-decoration: none;
          font-weight: 600;
          border-bottom: 2px solid transparent;
          transition: var(--transition);
        }

        .article-body a:hover {
          border-bottom-color: var(--color-primary-red);
        }

        .article-body .contact-info,
        .article-body .address-info {
          margin: 2rem 0;
          padding: 1.75rem;
          border-radius: 12px;
          box-shadow: var(--shadow-sm);
        }

        .article-body .contact-info {
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border: 2px solid var(--color-gray-light);
        }

        .article-body .address-info {
          background: linear-gradient(
            135deg,
            var(--color-primary-green) 0%,
            #146c43 100%
          );
          color: white !important;
        }

        .article-body .contact-info h5,
        .article-body .address-info h5 {
          font-size: 1.125rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        /* Partage social */
        .article-share {
          margin-top: 3rem;
          padding: 2rem;
          background: linear-gradient(
            135deg,
            rgba(220, 53, 69, 0.03) 0%,
            rgba(25, 135, 84, 0.03) 100%
          );
          border-radius: 12px;
          border: 1px solid var(--color-gray-light);
        }

        .share-title {
          font-size: 1rem;
          font-weight: 700;
          margin-bottom: 1.25rem;
          color: var(--color-dark);
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .social-buttons {
          display: flex;
          gap: 1rem;
        }

        .social-button {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-decoration: none;
          transition: var(--transition);
          box-shadow: var(--shadow-sm);
          font-size: 1.25rem;
        }

        .social-button:hover {
          transform: translateY(-4px);
          box-shadow: var(--shadow-md);
        }

        .linkedin {
          background: linear-gradient(135deg, #0077b5 0%, #005885 100%);
        }

        .twitter {
          background: linear-gradient(135deg, #1da1f2 0%, #0d8bd9 100%);
        }

        .facebook {
          background: linear-gradient(135deg, #4267b2 0%, #2d4373 100%);
        }

        /* Bouton retour */
        .btn-back {
          display: inline-flex;
          align-items: center;
          background: white;
          color: var(--color-gray-dark);
          padding: 0.875rem 1.75rem;
          border-radius: 50px;
          text-decoration: none;
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
          font-weight: 600;
          font-size: 0.938rem;
          border: 2px solid var(--color-gray-light);
        }

        .btn-back:hover {
          background: var(--color-primary-red);
          color: white;
          border-color: var(--color-primary-red);
          transform: translateX(-8px);
          box-shadow: var(--shadow-md);
        }

        /* Sidebar Widgets */
        .sidebar-widget {
          background: white;
          border-radius: 16px;
          padding: 2rem;
          margin-bottom: 2rem;
          box-shadow: var(--shadow-md);
          border: 1px solid rgba(0, 0, 0, 0.04);
          transition: var(--transition);
        }

        .sidebar-widget:hover {
          box-shadow: var(--shadow-lg);
        }

        .widget-title {
          font-family: var(--font-heading);
          font-size: 1.375rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid var(--color-gray-light);
          position: relative;
          color: var(--color-dark);
        }

        .widget-title::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 3px;
          background: linear-gradient(
            to right,
            var(--color-primary-red),
            var(--color-primary-green)
          );
          border-radius: 2px;
        }

        /* Widget Auteur */
        .author-profile {
          text-align: center;
        }

        .author-image {
          width: 90px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
          margin: 0 auto 1rem;
          border: 4px solid transparent;
          background: linear-gradient(white, white) padding-box,
            linear-gradient(
                135deg,
                var(--color-primary-red),
                var(--color-primary-green)
              )
              border-box;
          box-shadow: var(--shadow-sm);
        }

        .author-name {
          font-size: 1.125rem;
          font-weight: 700;
          margin-bottom: 0.5rem;
          color: var(--color-dark);
        }

        .author-bio {
          font-size: 0.875rem;
          color: var(--color-gray);
          line-height: 1.6;
          margin-bottom: 0;
        }

        /* Widget Articles similaires */
        .similar-articles {
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        }

        .similar-article {
          display: flex;
          text-decoration: none;
          color: inherit;
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          border-radius: 12px;
          overflow: hidden;
          transition: var(--transition);
          border: 1px solid var(--color-gray-light);
        }

        .similar-article:hover {
          transform: translateX(8px);
          box-shadow: var(--shadow-md);
          border-color: var(--color-primary-red);
        }

        .similar-article-image {
          width: 120px;
          height: 100px;
          flex-shrink: 0;
          position: relative;
          overflow: hidden;
        }

        .similar-article-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: var(--transition);
        }

        .similar-article:hover .similar-article-image img {
          transform: scale(1.1);
        }

        .similar-article-image .category-badge {
          position: absolute;
          top: 8px;
          left: 8px;
          padding: 0.25rem 0.75rem;
          font-size: 0.688rem;
          box-shadow: var(--shadow-sm);
        }

        .similar-article-content {
          padding: 1rem;
          flex: 1;
        }

        .similar-article-title {
          font-size: 0.938rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          color: var(--color-dark);
        }

        .similar-article-date {
          font-size: 0.813rem;
          color: var(--color-gray);
          display: flex;
          align-items: center;
          gap: 0.25rem;
          font-weight: 500;
        }

        /* Widget Newsletter */
        .newsletter-widget {
          background: linear-gradient(
            135deg,
            rgba(220, 53, 69, 0.05) 0%,
            rgba(25, 135, 84, 0.05) 100%
          );
        }

        .newsletter-desc {
          margin-bottom: 1.25rem;
          color: var(--color-gray-dark);
          font-size: 0.875rem;
          line-height: 1.6;
        }

        .newsletter-form .form-control {
          padding: 0.875rem 1.25rem;
          border: 2px solid var(--color-gray-light);
          border-radius: 50px;
          font-size: 0.938rem;
          transition: var(--transition);
        }

        .newsletter-form .form-control:focus {
          border-color: var(--color-primary-red);
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
          outline: none;
        }
        .newsletter-form .btn {
          border-radius: 50px;
          font-size: 0.938rem;
          font-weight: 600;
          transition: var(--transition);
        }
        .newsletter-form .btn:hover {
          background: var(--color-primary-green);
          border-color: var(--color-primary-green);
          box-shadow: 0 4px 12px rgba(25, 135, 84, 0.3);
        }
        .newsletter-form .btn:focus {
          box-shadow: 0 0 0 0.2rem rgba(25, 135, 84, 0.25);
          outline: none;
        }
        /* Responsive */
        @media (max-width: 992px) {
          .article-title {
            font-size: 2.25rem;
          }
          .article-meta {
            flex-direction: column;
            gap: 0.75rem;
          }
          .similar-article {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
          .similar-article-image {
            width: 100%;
            height: 150px;
          }
          .similar-article-content {
            padding: 1rem 0.5rem;
          }
          .similar-article-title {
            font-size: 1rem;
          }
          .similar-article-date {
            justify-content: center;
          }
        }
        @media (max-width: 576px) {
          .article-title {
            font-size: 1.875rem;
          }
          .article-excerpt .lead {
            font-size: 1.125rem;
          }
          .article-body {
            font-size: 1rem;
          }
          .article-body h3 {
            font-size: 1.5rem;
          }
          .similar-article-image {
            height: 120px;
          }
        }
      `}</style>
    </>
  );
};
export default DetailActu1;
